






































































































































































import moment from 'moment';

import { User } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData';
import {
  IRequisition,
  IRequisitionAttachment,
  IUserData,
  RequisitionStatusEnum
} from '@/models';
import { ErrorManager } from '@/models/error';
import { createFile } from '@/utils/helpers';

import RequisitionApproverList from './RequisitionApproverList.vue';
import RequisitionBuyerListMenu from './RequisitionBuyerListMenu.vue';
import RequisitionDetailDrawerOwnerSelector from './RequisitionDetailDrawerOwnerSelector.vue';
import RequisitionPONumberMenu from './RequisitionPONumberMenu.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import snackbar from '@/mixins/snackbar';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import RequisitionStatusDisplay from '../requisition-common/RequisitionStatusDisplay.vue';
import RequisitionProjectNumberEditor from './RequisitionProjectNumberEditor.vue';

export default mixins(auth, snackbar).extend({
  components: {
    RequisitionApproverList,
    RequisitionBuyerListMenu,
    RequisitionPONumberMenu,
    RequisitionDetailDrawerOwnerSelector,
    ErrorAlert,
    RequisitionStatusDisplay,
    RequisitionProjectNumberEditor
  },
  name: 'RequisitionDetailDrawer',

  props: {
    requisition: {
      type: Object as () => IRequisition,
      required: true
    }
  },

  data: () => ({
    mini: true,
    drawer: true,

    errorMessage: '',
    detailErrorMessage: ''
  }),

  computed: {
    authProvider(): any {
      return this.$altoleapAccounts.authProvider;
    },

    currentUser(): User {
      return this.authProvider.getCurrentUser;
    },

    isUserRequisitionOwner(): boolean {
      return (
        this.authProvider.getCurrentUser.id ==
        (this.requisition.owner as IUserData).id!
      );
    },

    /**
     * If user permission is 'PO Buyer', 'Requisition Admin' or 'Main Buyer'
     * and the PR state is in 'Buyer assigned' or 'Purchase in progress' */
    canAssignBuyer(): boolean {
      return (
        this.userHasRoles([
          'PO Buyer',
          'Purchase Requisition Admin',
          'Main Buyer'
        ]) &&
        [
          RequisitionStatusEnum.BuyerAssigned,
          RequisitionStatusEnum.PurchaseInProgress
        ].includes(this.requisition.status.value)
      );
    }
  },

  methods: {
    moment,

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    downloadAttachment(attachment: IRequisitionAttachment) {
      this.clearAllErrors();

      this.$services.fileLoader
        .downloadFile(attachment.file as string)
        .then(data => {
          createFile(data, attachment.filename!);
        })
        .then(() => {
          this.createSnack({
            color: 'success darken-1',
            type: 'download',
            right: true,
            useBtn: false,
            msg: `Downloaded file: '${attachment.filename}'`,
            btnText: 'Close'
          });
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);

          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        });
    }
  }
});
